<template>
  <div v-if="item">
   <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>
  </div>
</template>

<script>
import {  cardContent,cardUpdate } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "",
    item: null,
    fields: [
    
    ],
  }),
  props: ["id"],
  async created() {
    this.cardLink = `warehouse/options/${this.id}/images`;
    this.fields.push(
        {
            col:' col-12 col-md-12',
            key: "new_images",
            resultKey: "images",
            label: "Изображения",
            type: "imgs",
            link: this.cardLink
      }
    );
    this.item = await this.cardContent(this.cardLink);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(this.cardLink, this.item, this.fields, 'POST',true);
      if (item){
           this.item.images = item;
           this.item.new_images = item;
      }
    },
  },
};
</script>
<style>
</style>
